import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	fieldWrapper: {
		'& .MuiTextField-root': { minWidth: '378px' }
	},
	summaryHeader: {
		fontSize: '12px',
		color: '#1A1A35',
		fontWeight: '800',
		opacity: '.75'
	},
	text: {
		color: '#1A1A35',
		fontSize: '14px'
	}
}))

const EditMembershipDialog = (props) => {
	const classes = useStyles()
	let { isShown, setIsShown, updateMembership, membership } = props
	const [options, setOptions] = useState([])
	const [extend, setExtend] = useState()

	useEffect(() => {
		if (membership.type === 'vip_trial') {
			setOptions([
				{ number: 1, duration: 'day' },
				{ number: 2, duration: 'days' },
				{ number: 3, duration: 'days' },
				{ number: 4, duration: 'days' },
				{ number: 5, duration: 'days' },
				{ number: 6, duration: 'days' },
				{ number: 7, duration: 'days' },
				{ number: 1, duration: 'month' },
				{ number: 2, duration: 'months' },
				{ number: 3, duration: 'months' }
			])
		} else {
			setOptions([
				{ number: 1, duration: 'day' },
				{ number: 2, duration: 'days' },
				{ number: 3, duration: 'days' },
				{ number: 4, duration: 'days' },
				{ number: 5, duration: 'days' },
				{ number: 6, duration: 'days' },
				{ number: 7, duration: 'days' },
				{ number: 1, duration: 'month' }
			])
		}
	}, [membership])

	useEffect(() => {
		setExtend(options[0])
	}, [options])

	const saveMembership = () => {
		let { number, duration } = extend
		let endDate = moment(props.membership.end_date).add(number, duration).format()
		let startDate = moment(props.membership.start_date).add(number, duration).format()
		let newMem = { ...props.membership, end_date: endDate, start_date: startDate }

		updateMembership(newMem)
	}

	useEffect(() => {
		if (!isShown) setExtend(options[0])
	}, [isShown])

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '500px',
					maxWidth: '500px',
					width: '500px',
					height: '225px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				DELAY START DATE
			</DialogTitle>
			<DialogContent>
				<TextField
					variant="filled"
					select
					value={extend}
					label="Delay Start Date"
					onChange={(e) => {
						setExtend(e.target.value)
					}}>
					{options.map((option) => (
						<MenuItem key={option} value={option}>
							{option.number} {option.duration}
						</MenuItem>
					))}
				</TextField>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					disabled={!extend}
					onClick={() => {
						saveMembership()
						setIsShown(false)
					}}
					color="secondary">
					Save
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditMembershipDialog
